import type { ApprovalStatus } from './types';
import { Badge } from '@/components/ui/badge';
import { Clock, Send, CheckCircle2, XCircle, Zap } from 'lucide-react';

const config: Record<ApprovalStatus, { label: string; className: string; icon: React.ElementType }> = {
  Draft: { label: 'Entwurf', className: 'bg-muted text-muted-foreground border-border', icon: Clock },
  InReview: { label: 'In Review', className: 'bg-[hsl(var(--status-warning)/0.15)] text-[hsl(var(--status-warning))] border-[hsl(var(--status-warning)/0.3)]', icon: Send },
  Approved: { label: 'Genehmigt', className: 'bg-[hsl(var(--status-ok)/0.15)] text-[hsl(var(--status-ok))] border-[hsl(var(--status-ok)/0.3)]', icon: CheckCircle2 },
  Rejected: { label: 'Abgelehnt', className: 'bg-[hsl(var(--status-error)/0.15)] text-[hsl(var(--status-error))] border-[hsl(var(--status-error)/0.3)]', icon: XCircle },
  Live: { label: 'Live', className: 'bg-[hsl(var(--status-ok)/0.15)] text-[hsl(var(--status-ok))] border-[hsl(var(--status-ok)/0.3)]', icon: Zap },
};

export function ApprovalBadge({ status, className: extraClass }: { status: ApprovalStatus; className?: string }) {
  const { label, className, icon: Icon } = config[status] ?? config.Draft;
  return (
    <Badge variant="outline" className={`gap-1 text-[10px] shrink-0 ${className} ${extraClass ?? ''}`}>
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  );
}
